
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title: "Feed Instagram : 23 idées et exemples de feeds à adopter",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Lancez-vous sur Instagram avec un profil professionnel et attrayant. Découvrez des conseils pour bâtir une image qui capte l’attention de votre audience.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Feed Instagram : 23 idées et exemples de feeds à adopter",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Vous souhaitez vous lancer sur Instagram, adopter une image professionnelle et rendre votre profil attrayant ?",
        },
      ],
    };
  },
};
